/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_ScrapingInputs */

const en_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraping...`)
};

const de_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gescrapt...`)
};

const fr_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération en cours...`)
};

const es_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recopilando...`)
};

const it_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca...`)
};

const nl_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken...`)
};

const pl_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszukiwanie...`)
};

const fi_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haetaan...`)
};

const da_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skraber...`)
};

const sv_jobs_scraping = /** @type {(inputs: Jobs_ScrapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrapar...`)
};

/**
* | output |
* | --- |
* | "Scraping..." |
*
* @param {Jobs_ScrapingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_scraping = /** @type {((inputs?: Jobs_ScrapingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_ScrapingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_scraping(inputs)
	if (locale === "fr") return fr_jobs_scraping(inputs)
	if (locale === "es") return es_jobs_scraping(inputs)
	if (locale === "it") return it_jobs_scraping(inputs)
	if (locale === "nl") return nl_jobs_scraping(inputs)
	if (locale === "pl") return pl_jobs_scraping(inputs)
	if (locale === "fi") return fi_jobs_scraping(inputs)
	if (locale === "da") return da_jobs_scraping(inputs)
	if (locale === "sv") return sv_jobs_scraping(inputs)
	return en_jobs_scraping(inputs)
});